import React, { useEffect, useState } from 'react';
import { joinClasses } from '../../../../Utils/className.util';
import Text from '../Text';
// @ts-ignore
import styles from './Checkbox.module.scss';

interface Props {
	tx?: string;
	onChange?: any;
	value?: boolean;
	firstUpper?: boolean;
	disabled?: boolean;
	className?: string;
	children?: React.ReactChild;
}

const Checkbox: React.FC<Props> = ({ value, tx, disabled, firstUpper, className, onChange, children }) => {
	const [checked, setChecked] = useState(value);

	useEffect(() => {
		if (!disabled) {
			setChecked(value);
		}
	}, [value]);

	const handleClick = () => {
		setChecked(prev => !prev);
		onChange(!checked);
	};

	return (
		<div
			className={joinClasses([
				styles.wrapper,
				disabled ? styles.disabled : undefined,
				className,
			])}
			onClick={handleClick}>
			<div
				className={joinClasses([
					styles.checkbox,
					checked && styles.active,
					className,
				])}
			/>
			{tx && (
				<div>
					<Text
						className={styles.title}
						tx={tx}
						firstUpper={firstUpper}
					/>
				</div>
			)}
			{children && <div className={styles.childrenWrapper}>{children}</div>}
		</div>
	);
};

export default Checkbox;